export const enum eAccountSettingTabNames {
  Account = 'AbpAccount::Menu:Account',
  TimeZone = 'AbpSettingManagement::Menu:TimeZone'
}
